import unitCardEn from "./locales/en.json";

export const UNIT_CARD_NS = "unitCard" as const;

export const UnitCardTranslations = {
  en: {
    [UNIT_CARD_NS]: {
      ...unitCardEn,
    },
  },
};
